import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import AssignmentIcon from '@material-ui/icons/Assignment';
import DraftsIcon from '@material-ui/icons/Drafts';
import FolderShared from '@material-ui/icons/FolderShared';
import SendIcon from '@material-ui/icons/Send';
import Schedule from '@material-ui/icons/Schedule';
import People from '@material-ui/icons/People';
import BusinessCenter from '@material-ui/icons/BusinessCenter';
import AttachMoney from '@material-ui/icons/AttachMoney';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import StorageIcon from '@material-ui/icons/Storage';
import { Link } from 'react-router-dom';

export const mailFolderListItems = (
  <div>
    <Link to="/organisations">
      <ListItem button>
        <ListItemIcon>
          <FolderShared />
        </ListItemIcon>
        <ListItemText primary="Organisations" />
      </ListItem>
    </Link>
    <Link to="/calculator">
      <ListItem button>
        <ListItemIcon>
          <AccountBalanceIcon />
        </ListItemIcon>
        <ListItemText primary="Calculator" />
      </ListItem>
    </Link>
    <Link to="/applications">
      <ListItem button>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="Applications" />
      </ListItem>
    </Link>
    <Link to="/loans">
      <ListItem button>
        <ListItemIcon>
          <AttachMoney />
        </ListItemIcon>
        <ListItemText primary="Loans" />
      </ListItem>
    </Link>
    <Link to="/loan_schedule_reminder">
      <ListItem button>
        <ListItemIcon>
          <Schedule />
        </ListItemIcon>
        <ListItemText primary="Loan Reminder" />
      </ListItem>
    </Link>
    <Link to="/payway_transactions">
      <ListItem button>
        <ListItemIcon>
          <StorageIcon />
        </ListItemIcon>
        <ListItemText primary="Payway Transactions" />
      </ListItem>
    </Link>
    <Link to="/referrals">
      <ListItem button>
        <ListItemIcon>
          <People />
        </ListItemIcon>
        <ListItemText primary="Referrals" />
      </ListItem>
    </Link>
    <Link to="/investors">
      <ListItem button>
        <ListItemIcon>
          <BusinessCenter />
        </ListItemIcon>
        <ListItemText primary="Investors" />
      </ListItem>
    </Link>
    <div style={{ display: "none" }}>
      <ListItem button>
        <ListItemIcon>
          <SendIcon />
        </ListItemIcon>
        <ListItemText primary="Send mail" />
      </ListItem>
      <ListItem button>
        <ListItemIcon>
          <DraftsIcon />
        </ListItemIcon>
        <ListItemText primary="Drafts" />
      </ListItem>
    </div>
  </div>
);

export const otherMailFolderListItems = (
  null
);



// WEBPACK FOOTER //
// ./src/containers/Admin/Sidebar/index.js